import {openDialog} from 'platform/components';

import i18n from '@dms/i18n';
import {testIds} from '@dms/routes';

import {CreateCarisServiceRequestForm} from '../components/CreateCarisServiceRequestForm';

export const openCreateCarisServiceRequestDialog = (vehicleId: string) =>
  openDialog(
    <CreateCarisServiceRequestForm
      vehicleId={vehicleId}
      data-testid={testIds.vehicles.carisServiceRequests('createForm')}
    />,
    {
      id: 'createCarisServiceRequestDialog',
      title: i18n.t('entity.carisServiceRequest.actions.create'),
      'data-testid': testIds.vehicles.carisServiceRequests('createDialog'),
    }
  );
